/**
 * Returns a boolean indicating if browser is too old for Echoline app.
 *
 * Echoline app is officially compatible with all "evergreen" browsers, which includes Chrome, Firefox, Safari and
 * Edge/Chromium, and all browsers based on Chromium. This method currently detects Shadow DOM feature, which was
 * neither supported by Internet Explorer nor by Edge/HTML (prior to Edge transition to Chromium).
 * @return {boolean}
 */
export default function isOldBrowser() {
    // noinspection JSUnresolvedVariable
    return !(document.head.attachShadow || document.head.createShadowRoot);
}
